import { message } from 'antd';
import { useEffect } from 'react';

import { Form, FormItem } from '../../../../components/antd/Form';
import { Input } from '../../../../components/antd/Input';
import { Select } from '../../../../components/antd/Select';
import {
  useCreateProductGroupMutation,
  useUpdateProductGroupMutation,
} from '../../../../services/cargoApi';
import { ProductGroup } from '../../../../types';
import { cargoNatureList } from '../../../../utils/lists';
import {
  RegisterHeaderForm,
  RegisterHeaderFormProps,
} from '../registerHeaderForm';
import { FormItemsWrapper } from './cargoForm';

type GroupFormProps = RegisterHeaderFormProps & {
  selectedProductGroup?: ProductGroup | null;
};

export function GroupForm(props: GroupFormProps) {
  const [form] = Form.useForm();
  const { selectedProductGroup } = props;

  const [
    createProductGroup,
    { isSuccess: isSuccessCreate, isError: isErrorCreate },
  ] = useCreateProductGroupMutation();
  const [
    updateProductGroup,
    { isSuccess: isSuccessUpdate, isError: isErrorUpdate },
  ] = useUpdateProductGroupMutation();

  const isEdit = Boolean(selectedProductGroup?.id);

  async function handleFormSubmit(values: any) {
    if (isEdit && selectedProductGroup?.id) {
      await updateProductGroup({
        id: selectedProductGroup.id,
        ...values,
      });
    } else {
      await createProductGroup({ ...values } as ProductGroup);
    }
  }

  useEffect(() => {
    if (isSuccessCreate) {
      message.success('Grupo de produto criado');
      props.onClose(null);
    } else if (isSuccessUpdate) {
      message.success('Grupo de produto atualizado');
      props.onClose(null);
    } else if (isErrorCreate || isErrorUpdate) {
      message.error(
        'Ocorreu um erro ao salvar o grupo de produto, se o erro persistir entre em contato com o suporte'
      );
    }
  }, [isSuccessCreate, isSuccessUpdate, isErrorCreate, isErrorUpdate]);

  return (
    <Form
      form={form}
      name="product_group"
      layout="vertical"
      onFinish={handleFormSubmit}
      initialValues={
        selectedProductGroup
          ? {
              name: selectedProductGroup.name,
              nature_of_cargo: selectedProductGroup.nature_of_cargo?.id,
            }
          : undefined
      }
    >
      <RegisterHeaderForm onClose={props.onClose} formName="product_group">
        <div className="title">
          {isEdit ? 'EDITAR GRUPO DE PRODUTO' : 'NOVO GRUPO DE PRODUTO'}
        </div>
      </RegisterHeaderForm>
      <FormItemsWrapper>
        <FormItem
          name="nature_of_cargo"
          label="Natureza da carga"
          rules={[{ required: true, message: 'Campo obrigatório' }]}
        >
          <Select>
            {cargoNatureList.map((currentCargoNature) => {
              return (
                <Select.Option
                  key={currentCargoNature.id}
                  value={currentCargoNature.id}
                >
                  {currentCargoNature.name}
                </Select.Option>
              );
            })}
          </Select>
        </FormItem>
        <FormItem
          name="name"
          label="Nome do grupo"
          rules={[{ required: true, message: 'Campo obrigatório' }]}
        >
          <Input />
        </FormItem>
      </FormItemsWrapper>
    </Form>
  );
}
